import React from "react"
import SbEditable from "storyblok-react"

import Components from "../components/components.js"

import { BigBlogTeasers } from "gatsby-theme-gba"

const BigBlogTeasersEditable = ({ blok }) => (
  <SbEditable content={blok}>
    <BigBlogTeasers
      heading={blok.headline}
      buttonLink={
        blok.bigBlogTeaserListing ? blok.bigBlogTeaserListing.full_slug : ""
      }
      buttonText={blok.callToAction}
      linkTarget={blok.linkTarget}
      currentLanguage={blok.currentLanguage}
      seoLinks={blok.seoLinks}
    >
      {blok.entries &&
        blok.entries
          .filter(function(innerBlok) {
            if (!innerBlok.content) {
              return false // skip
            }
            return true
          })
          .map((innerBlok, index) => {
            let content = innerBlok.content
            content.component = "bigBlogTeaser"
            content.link = innerBlok.full_slug
            content.date = innerBlok.sort_by_date
            content.tagList = innerBlok.tag_list
            content.currentLanguage = blok.currentLanguage
            content.seoLinks = blok.seoLinks
            const component = React.createElement(
              Components(content.component),
              {
                key: index,
                blok: content,
              }
            )
            return component
          })}
    </BigBlogTeasers>
  </SbEditable>
)

export default BigBlogTeasersEditable
